import { useUser } from "../../store/userState";
import AdminRoutes from "./Admin.Route";

const ConsoleRoutes = () => {
  const { user } = useUser();
  // 0 for admin
  if (user?.role === 0) return <AdminRoutes />;
  else if (user?.role >= 1) return null;

  return <p>Loading...</p>;
};

export default ConsoleRoutes;
